export default __webpack_public_path__ + "static/media/file-text-loader.83de5c2d.svg";